import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { botFlowDataAtom, flowValidationAtom } from '../../../../Services/_states';
import SearchableDropdown from '../../Common/SearchableDropdown/SearchableDropdown.tsx';
import { Flow } from '../../../../interfaces/Flowbuilder.interface.ts';
import { FlowBuilderActions } from '../../../../Services/_actions/index.js';
import { PaginatedResponse } from '../../../../interfaces/Management.interface.ts';
import { useSnackBar } from '../../Common/SnackBar/index.tsx';
import { useParams } from 'react-router';

const ExistingFlowNode = ({ data, botFlowData, showFlowNameField = true }: any) => {
  const { showSnackBar } = useSnackBar();
  const flowValidationObj = useRecoilValue(flowValidationAtom);
  const { flowId } = useParams();
  const actions = FlowBuilderActions();
  const [flowListData, setFlowListData] = useState < PaginatedResponse > ({
    list: [],
    pages: 0,
    count: 0,
  });
  const [loading, setLoading] = useState(false);
  const [flowFilters, setFlowFilters] = useState({
    page: 0,
    rowsPerPage: 10,
    search: '',
    sortBy: 'created_at',
    sortOrder: 'desc',
    totalCount: 0,
    organisationId: '',
    selectedOrganisation: null,
    botNumber: botFlowData?.phone_number_id ?? '',
    channelObj: null,
  });
  const fetchFlowList = async (filterObj) => {
    setLoading(true);
    try {
      let res = await actions.getFlowList(filterObj);
      if (res?.status === 200 && res?.data) {
        setFlowListData(res.data);
        setFlowFilters({ ...flowFilters, page: flowFilters?.page + 1 });
      } else {
        showSnackBar('Unexpected response status or data:', 'error');
      }
    } catch (error) {
      showSnackBar('Failed to fetch Flows:', 'error');
    }
    setLoading(false);
  };

  const handleSearch = (query) => {
    setFlowFilters({ ...flowFilters, search: query });
    fetchFlowList({ ...flowFilters, search: query });
  };

  const loadMoreFlows = async () => {
    if (flowFilters.page < (flowListData.pages || 0)) {
      setLoading(true);
      let listData: any[] = Array.isArray(flowListData?.list) ? [...flowListData?.list] : [];
      const data = { ...flowFilters, page: flowFilters.page + 1 };
      try {
        const res = await actions.getFlowList(data);
        if (res?.status === 200 && res?.data?.list && Array.isArray(res.data.list)) {
          listData = [...listData, ...res.data.list];
          setFlowListData({ ...res.data, list: listData });
          setFlowFilters(data);
        } else {
          showSnackBar('Unexpected response structure or status:', 'error');
        }
      } catch (error) {
        showSnackBar('Error loading more organizations:', 'error');
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchFlowList(flowFilters);
  }, []);
  return (
    <Box>
      <SearchableDropdown
        options={flowListData?.list || []}
        value={data?.selectedFlow || null}
        fetchMoreOptions={flowFilters.page < (flowListData?.pages || 0) ? loadMoreFlows : undefined}
        onSearch={handleSearch}
        // onChange={(value) => {
        //     console.log("Selected Flow in ExistingFlowNode:", value);
        //     data.onChange(data.id, { selectedFlow: value });
        // }}
        onChange={(value) => {
          data.onChange(data.id, {
            selectedFlow: value ? {
              _id: value?._id,
              title: value?.title,
            } : null,
          });
        }}
        loading={loading}
        labelKey="title"
        valueKey="_id"
        getOptionDisabled={(option) => option?._id === flowId}
      />
      {showFlowNameField && data?.selectedFlow && (
        <TextField
          label="Flow Name"
          value={data?.selectedFlow?.title}
          showFlowNameField={true}
          variant="outlined"
          size="small"
          fullWidth
          disabled
          sx={{ marginTop: 2 }}
        />
      )}
      {flowValidationObj[data?.id]?.existingFlow && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.existingFlow}
        </Typography>
      )}
    </Box>
  );
};

export default ExistingFlowNode;
